export const GENDER_OPTIONS = ['man', 'woman'].map((o) => ({ value: o, label: o.charAt(0).toUpperCase() + o.slice(1) }))
export const GENDER_OPTIONS_2 = [
    ...GENDER_OPTIONS,
    {
        value: 'other',
        label: 'Other',
    },
]

export const GENDER_OBJECT = GENDER_OPTIONS_2.reduce((t, { value, label }) => ({ ...t, [value]: label }), {})

export default {
    GENDER_OPTIONS,
    GENDER_OPTIONS_2,
    GENDER_OBJECT,
}
